import {IssueTypeToken} from '@github-ui/issue-type-token'

import styles from './IssueTypeIndicator.module.css'

type Props = {
  issueTypeName: string
  issueTypeColor: string
  getIssueTypeHref: (login: string) => string
}

export const IssueTypeIndicator = ({issueTypeName, issueTypeColor, getIssueTypeHref}: Props) => {
  const getTooltipText = (isTruncated: boolean) => {
    return isTruncated ? issueTypeName : undefined
  }

  return (
    <div className={styles.container}>
      <IssueTypeToken
        name={issueTypeName}
        color={issueTypeColor}
        href={getIssueTypeHref(issueTypeName)}
        getTooltipText={getTooltipText}
      />
    </div>
  )
}

try{ IssueTypeIndicator.displayName ||= 'IssueTypeIndicator' } catch {}